import { DateTime } from 'luxon';

export function fromISOtoMMddyyyy(date: string): string {
  if (!date) {
    throw new Error('The date parameter is required.');
  }
  const dt = DateTime.fromISO(date);
  if (!dt.isValid) {
    throw new Error('Invalid ISO date string.');
  }
  return dt.toFormat('MM/dd/yyyy');
}

export const formatDate = (date: string | Date | number): string => {
  if (!date && date !== 0) {
    return '';
  }

  let dt: DateTime;
  if (typeof date === 'number') {
    dt = DateTime.fromMillis(date);
  } else if (typeof date === 'string') {
    dt = DateTime.fromISO(date);
    if (!dt.isValid) {
      dt = DateTime.fromMillis(Number(date));
    }
  } else if (date instanceof Date) {
    dt = DateTime.fromJSDate(date);
  } else {
    return '';
  }

  if (!dt.isValid) {
    return '';
  }

  return dt.toFormat('MM/dd/yyyy');
};
